import {
  TaskLabel,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import { resolveSyncAction, SyncAction } from './taskSyncActions';
import { useEntitySync } from './useEntitySync';
import { useFetchTaskLabels } from '../../../hooks/taskLabels/useFetchTaskLabels';
import { useInboxEntriesStore } from '../../../store';

export function useTaskLabelsSync() {
  const createTaskLabel = useInboxEntriesStore(
    (s) => s.taskManager.activeTaskGroup.createTaskLabel,
  );
  const updateTaskLabel = useInboxEntriesStore(
    (s) => s.taskManager.activeTaskGroup.updateTaskLabel,
  );
  const removeTaskLabel = useInboxEntriesStore(
    (s) => s.taskManager.activeTaskGroup.removeTaskLabel,
  );
  const { handleFetchTaskLabels } = useFetchTaskLabels();

  const apply = (event: WebSocketAction, item: TaskLabel) => {
    const active = useInboxEntriesStore.getState().taskManager.activeTaskGroup;
    const taskLabel = active.taskLabels.find((l) => l.id === item.id);
    const belongs = item.taskGroupId === active.taskGroupId;
    const syncAction = resolveSyncAction(event, {
      exists: !!taskLabel,
      belongs,
    });
    switch (syncAction) {
      case SyncAction.CREATE:
        createTaskLabel(item);
        break;
      case SyncAction.UPDATE:
        updateTaskLabel(item);
        break;
      case SyncAction.REMOVE:
        removeTaskLabel(item.id);
        break;
      default:
        break;
    }
  };

  useEntitySync<TaskLabel>(WebSocketEntityType.TaskLabel, {
    onInsert: (item) => apply(WebSocketAction.INSERT, item),
    onModify: (item) => apply(WebSocketAction.MODIFY, item),
    onRemove: (item) => apply(WebSocketAction.REMOVE, item),
    onReconnect: async () => {
      const { taskGroupId } =
        useInboxEntriesStore.getState().taskManager.activeTaskGroup;
      if (!taskGroupId) {
        return;
      }
      log.info(
        '[TaskLabelsSync] Reconnected after long pause, refetching labels',
      );
      try {
        await handleFetchTaskLabels({ taskGroupId });
      } catch (error) {
        log.error('[TaskLabelsSync] Failed to refetch task labels:', error);
      }
    },
  });
}
